import * as React from 'react'
import {getPicture} from '../../../../utils/tools'
// tslint:disable-next-line
const {LazyLoadComponent} = require('react-lazy-load-image-component')

interface ImageViewProp {
    url: string
    width?: number
}

export function ImageView(props: ImageViewProp) {
    return (
        <div id="lazy-loader-component">
            <LazyLoadComponent>
                <picture>
                    <source type="image/webp" srcSet={getPicture(props.url, props.width, 'webp')} />
                    <img src={getPicture(props.url, props.width)} alt=""/>
                </picture>
            </LazyLoadComponent>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/views/Home/components/ImageView/ImageView.tsx